import React from 'react';
import { useFormikContext, FieldArray } from 'formik';
import {Button, Icon, Input} from '../UI';
import { FormValues } from '../../common/interfaces';
import {MaskedInput} from '../UI/MaskedInput';

export const EmploymentRecords = () => {
  const { values } = useFormikContext<FormValues>();

  return (
    <FieldArray name="records">
      {({ push, remove }) => (
        <div className="space-y-4">
          {values.records.map((_, index) => (
            <div key={index} className="flex">
              <span className="w-10 text-slate-500 font-semibold mt-8">{index + 1}.</span>

              <div className="w-full flex flex-col">
                <div className="grid grid-cols-3 gap-6">
                  <Input name={`records.${index}.employer`} label="Employer" />
                  <MaskedInput name={`records.${index}.from`} label="Employed From" mask='99/9999'  />
                  <MaskedInput name={`records.${index}.to`} label="Employed To" mask='99/9999' />
                </div>
                <div className="grid grid-cols-3 gap-6">
                  <Input name={`records.${index}.address`} label="Address" />
                  <MaskedInput name={`records.${index}.phone`} label="Phone Number" mask='(999) 999-9999' />
                  <Input name={`records.${index}.supervisor`} label="Supervisor" />
                </div>
                <div className="grid grid-cols-2 gap-6">
                  <Input name={`records.${index}.position`} label="Position" />
                  <Input name={`records.${index}.leavingReason`} label="Reason For Leaving" />
                </div>
              </div>

              {values.records.length > 1 && (
                <Button onClick={() => remove(index)}>
                  <Icon prefix='fal' icon='trash-alt' />
                </Button>
              )}
            </div>
          ))}

          <div className="flex justify-end">
            <Button
              type="button"
              size='xs'
              onClick={() =>
                push({
                  employer: '',
                  from: '',
                  to: '',
                  address: '',
                  phone: '',
                  supervisor: '',
                  position: '',
                  leavingReason: ''
                })
              }
            >
              + Add Employment Record
            </Button>
          </div>
        </div>
      )}
    </FieldArray>
  );
};